import { render, staticRenderFns } from "./SetupFilterAction.vue?vue&type=template&id=724d760f&"
import script from "./SetupFilterAction.vue?vue&type=script&lang=js&"
export * from "./SetupFilterAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports